import {AfterViewInit, Component, ElementRef, Type, ViewChild, ViewContainerRef} from '@angular/core';
import {Observable, Observer} from "rxjs";
import {DialogService} from "../../../services/dialog/dialog.service";
import {Dialog} from "../../../interfaces/dialog/dialog";
import {DialogParams} from "../../../interfaces/dialog/dialog-params";
import {NgClass} from "@angular/common";
import Modal from "bootstrap/js/dist/modal";

@Component({
  selector: 'app-dialog-modal',
  imports: [
    NgClass
  ],
  templateUrl: './dialog-modal.component.html',
  styleUrl: './dialog-modal.component.scss'
})
export class DialogModalComponent implements AfterViewInit {

  params: DialogParams | null = null;
  modal: Modal | null = null;
  closeParams: any = null;
  subscriber: Observer<any> | null = null;

  @ViewChild('modal') modalElement!: ElementRef;
  @ViewChild('container', {read: ViewContainerRef}) container: ViewContainerRef | null = null;

  constructor(
    private el: ElementRef,
    private dialog: DialogService,
  ) {
    this.dialog.setDialogModalComponent(this);
  }

  ngAfterViewInit(): void {
    this.modalElement.nativeElement.addEventListener('hidden.bs.modal', (event: any) => {
      this.subscriber?.next(this.closeParams);
      this.closeParams = null;

      const body = document.querySelector('body');
      if (body) {
        body.style.position = 'static';
      }
    });
  }

  open(componentType: Type<Dialog>, params: DialogParams): Observable<any> {
    this.params = params;

    this.container?.clear();
    const dialogComponentRef: any = this.container?.createComponent(componentType);
    const dialogComponent: Dialog = dialogComponentRef.instance;
    dialogComponent.onDialogInit(this.params);

    return new Observable<any>((subscriber) => {
      const body = document.querySelector('body');
      if (body) {
        body.style.position = 'fixed';
      }

      const element = this.el.nativeElement;
      const modalElement = element.querySelector('.modal');
      this.modal = new Modal(modalElement, {backdrop: params.backdrop !== false ? true : 'static'});
      this.subscriber = subscriber;
      this.modal?.show();
    });
  }

  close(params: any = null): void {
    this.closeParams = params;
    this.modal?.hide();
  }

  getClasses(): string {
    return this.params?.class ?? '';
  }
}
